export function capitalizeFirstLetter(value: string) {
  const words = value.split(' ');
  let capitalizedWords = '';

  for (let i = 0; i < words.length; i += 1) {
    const word = words[i];
    if (word.length === 1) {
      capitalizedWords += `${word.toUpperCase()} `;
    } else {
      capitalizedWords += `${word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()} `;
    }
  }
  return capitalizedWords.trim();
}
